<template>
  <section
    :class="[isBookingWidgetIframe ? style['full-overlay-no-header'] : style['full-overlay']]"
    :style="currentUserComponent === 'BookingWidgetIframe' ? { padding: 0 } : {}"
  >
    <component :is="currentUserComponent" v-bind="currentProps"></component>

    <button
      v-if="currentUserComponent !== 'BookingWidgetIframe'"
      :class="style['close-button']"
      type="button"
      @click="closeClick"
    >
      {{ $t('close') }}
    </button>
  </section>
</template>

<script>
import NewPaymentMethod from './NewPaymentMethod.vue'
import GetEmail from './GetEmail.vue'
import SignUp from './SignUp.vue'
import SignIn from './SignIn.vue'
import SignOut from './SignOut.vue'
import ForgotPassword from './ForgotPassword.vue'
import BookingWidgetIframe from './BookingWidgetIframe'
import style from './scss/_users.scss'
import { useUserStore } from 'Store/user'
import { useAppStore } from 'Store/app'
import { useSettingsStore } from 'Store/settings'
import { useColorsStore } from 'Store/colors'
import { useChatStore } from 'Store/chat'
import { useUserPanelStore } from 'Store/user-panel'
import { mapState } from 'pinia'

export default {
  components: {
    NewPaymentMethod,
    GetEmail,
    SignUp,
    BookingWidgetIframe,
    SignIn,
    SignOut,
    ForgotPassword
  },
  props: {
    userProps: {
      choosePaymentMethod: { type: Function, required: true }
    },
    displayHeader: { type: Boolean, default: true }
  },

  setup() {
    return {
      userStore: useUserStore(),
      appStore: useAppStore(),
      settingsStore: useSettingsStore(),
      userPanelStore: useUserPanelStore()
    }
  },

  data() {
    return {
      snsUserData: {},
      style
    }
  },
  computed: {
    ...mapState(useUserStore, ['isKnownUser']),
    ...mapState(useSettingsStore, {
      isFacilitySignInEnabled: 'getFacilitySignIn'
    }),
    ...mapState(useSettingsStore, ['settings']),
    ...mapState(useChatStore, {
      chatID: 'chatId'
    }),

    currentUserComponent() {
      return this.isKnownUser &&
        this.userPanelStore.panel !== 'NewPaymentMethod' &&
        this.userPanelStore.panel !== 'GetEmail'
        ? 'SignOut'
        : this.userPanelStore.panel
    },

    isBookingWidgetIframe() {
      return this.currentUserComponent === 'BookingWidgetIframe'
    },
    currentProps() {
      if (this.currentUserComponent === 'NewPaymentMethod') {
        return {
          settings: this.settings,
          choosePaymentMethod: this.userProps.choosePaymentMethod,
          closeUserPanel: this.userProps.closeUserPanel
        }
      } else if (this.currentUserComponent === 'ForgotPassword') {
        return {
          settings: this.settings,
          goToUserComponent: this.goToUserComponent
        }
      } else if (this.currentUserComponent === 'SignIn') {
        return {
          settings: this.settings,
          closeUserPanel: this.userProps.closeUserPanel,
          goToUserComponent: this.goToUserComponent
        }
      } else if (this.currentUserComponent === 'SignUp') {
        return {
          settings: this.settings,
          closeUserPanel: this.userProps.closeUserPanel,
          userData: this.snsUserData,
          goToUserComponent: this.goToUserComponent
        }
      } else if (this.currentUserComponent === 'SignOut') {
        return {
          settings: this.settings,
          closeUserPanel: this.userProps.closeUserPanel
        }
      } else if (this.currentUserComponent === 'GetEmail') {
        return {
          settings: this.settings,
          closeUserPanel: this.userProps.closeUserPanel,
          goToUserComponent: this.goToUserComponent
        }
      } else if (this.currentUserComponent === 'BookingWidgetIframe') {
        return {
          closeUserPanel: this.userProps.closeUserPanel,
          params: this.userProps.bwIframeParams || {}
        }
      } else {
        return {}
      }
    }
  },
  watch: {
    isBookingWidgetIframe: {
      immediate: true,
      handler(val) {
        this.$emit('update:displayHeader', !val)
      }
    }
  },

  created() {
    if (this.isFacilitySignInEnabled) {
      window.addEventListener('message', this.handleMessageFromBW)
    }
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handleMessageFromBW)
  },

  methods: {
    closeUserPanel() {
      this.userPanelStore.setOpen(false)
    },

    goToUserComponent(component) {
      this.userPanelStore.setPanel(component)
    },
    closeClick() {
      this.userProps.closeUserPanel()
      this.$emit('update:displayHeader', true)
      this.appStore.setAutoMessageAuthId(null)
      this.appStore.setAutoMessageAuthType(null)
    },
    handleMessageFromBW(event) {
      if (event.origin !== this.settingsStore.bookingWidgetURL) return

      const { data } = event
      if (
        (data.action === 'close' && data.isInCBIframe) ||
        (data.action === 'receiveTriplabotSession' && data.session)
      ) {
        this.userProps.closeUserPanel()
        this.$emit('update:displayHeader', true)
        this.appStore.setAutoMessageAuthId(null)
        this.appStore.setAutoMessageAuthType(null)
      }
    }
  }
}
</script>
